<template>
  <div class="p-2">
    <aha-input
      type="text"
      class="w-full"
      :placeholder="$i18nPresenter.t('Link Content Thumbnail')"
      v-model="slideActive.contentTemplateThumbnail"
      @input="changeContentTemplateThumbnail"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import debounce from 'debounce'
import SlideApi from '@/api/slide'

export default {
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    changeContentTemplateThumbnail: debounce(async function onChangeTemplateThumbnail() {
      const payload = {
        presentationId: this.presentation.id,
        accessCode: this.presentation.uniqueAccessCode,
        contentTemplateThumbnail: this.slideActive.contentTemplateThumbnail,
      }
      await SlideApi.updateSlideById(this.slideActive.id, payload)
      this.updateSlideActiveAction({
        ...payload,
      })
    }, 500),
  },
}
</script>

<style lang="scss" scoped>

</style>
